<mg-report-table
  matSort
  [dataSourceService]="ds"
  (matSortChange)="ds.sort($event)">
  <mg-history-column [datasource]="ds"></mg-history-column>
</mg-report-table>
